import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Employees: 'Employees',

  // Column headers
  Name: 'Name',
  Phone: 'Phone',
  Email: 'Email',
  DateOfBirth: 'Date of birth',
  PriceProfile: 'Price profile',
  OwnCompany: 'OwnCompany',
  Teams: 'Team(s)',
  Role: 'Role(s)',
  EmployeeType: 'EmployeeType',
  EmployeeNumber: 'EmployeeNumber',
  EmployedSince: 'Employed since',
  EndDate: 'End date',
  EmploymentStartDate: 'EmploymentStartDate',
  EmploymentEndDate: 'EmploymentEndDate',
  License: 'License',
  Confirmed: 'Confirmed',
  TwoFaEnabled: '2FA',
  Reset: 'Reset',
  Visible: 'Visible',
  Delete: 'Delete',
  InternalPrice: 'Internal price',
  IntraCompanyPrice: 'Intra company price',

  // Buttons and actions
  ColumnConfig: 'Column config',
  Export: 'Export',
  ExportEmployeesToExcel: 'Export employees to Excel',
  ExportOvertimeCorrectionsToExcel: 'Export overtime corrections to Excel',

  // Employee actions
  OpenDetails: 'Open details',
  SendPasswordResetEmail: 'Send password reset e-mail',
  HiddenInApplication: 'Hidden in application',
  VisibleInApplication: 'Visible in application',
  RestoreEmployee: 'Restore employee',
  DeleteEmployee: 'Delete employee',

  // Modal titles
  SelectColumns: 'Select columns',
  SelectPeriod: 'Select period',
  // Messages
  AllCompanies: 'All companies',
  AllRoles: 'All roles',
  AllProfiles: 'All profiles',
  WithLabels: 'With labels',
  DefaultRoles: 'Default Roles',
  CustomRoles: 'Custom Roles',
  ShowNotVisibleInApplication: 'Show not visible in application',
  SearchEmployee: 'Search employee',
  ResetFilters: 'Reset filters',
  Period: 'Period',
  Cancel: 'Cancel',
  // Button labels
  Add: 'Add',
  AddEmployee: 'Add employee',
  AddTemporaryEmployee: 'Add temporary employee',

  // License information
  TotalLicenses: 'Total Licenses',
  Assigned: 'Assigned',
  Available: 'Available',
  TotalTemporary: 'Total temporary',
  AssignedTemporary: 'Assigned temporary',
  AvailableTemporary: 'Available temporary',
  FreeLicense: 'Free license',
  StandardLicense: 'Standard license',
  TemporaryLicense: 'Temporary license',
  NoLicense: 'No license',

  // Other labels
  Unassigned: 'Unassigned',

  // Success/Error messages
  msgPasswordResetOtherUser: 'Password reset email sent successfully',
  msgEmployeeRestoreSuccesful: 'Employee restored successfully',
  ExportToExcelStarted: 'Export to Excel started',
  DeleteEmployeeQuestion: 'Are you sure you want to delete this employee?',
  KeepShowingEmployeeInApplication: 'Keep showing this employee in the application',
  Ok: 'Ok',
  msgEmpRemoved: 'Employee removed',

  // Restore Employee Modal
  LicenseType: 'License type',
  AvailableStandardLicense: 'Available standard license',
  NewStandardLicense: 'New standard license',
  AvailableTemporaryLicense: 'Available temporary license',
  NewTemporaryLicense: 'New temporary license',
  TemporaryLicense: 'Temporary license',
  SelectLicense: 'Select a license',
  Months: 'Months',
  Period: 'Period',
  SubtractOneMonth: 'Subtract one month',
  AddOneMonth: 'Add one month',

  // Global actions
  GlobalActions: 'Global actions',
  EmployeeGlobalActionsTooltip: 'Select at least one employee',
  UpdateInternalPrice: 'Update internal price',
  UpdateIntraCompanyPrice: 'Update intra company price',
  UpdateProfile: 'Update profile',
  AddOrRemoveTags: 'Add or remove tags',
  UpdateProductivityPercentage: 'Update productivity percentage',
  ProductivityPercentage: 'Productivity percentage',
  EmployeesWithoutTimetableSkipped:
    '{0} employee(s) were not updated because they have no timetable configured.',
  Action: 'Action',
  AddTags: 'Add tags',
  RemoveTags: 'Remove tags',
  Tags: 'Tags',
  EnterTag: 'Enter tag',

  // Update amount modal
  Method: 'Method',
  Percentage: 'Percentage',
  Amount: 'Amount',
  RoundingMethod: 'Rounding method',
  RoundTo: 'Round to',
  Digits: 'Digits',
  Example: 'Example',
  RecalculateRegistrationsWithNewPrice: 'Recalculate registrations with new price.',
  RegistrationsBetween: 'Registrations between',

  // Warning Messages
  UseUnusedLicenseWarning: 'We will use an unused license that you already paid for.',
  NewStandardLicenseWarning:
    'An extra license of {price} will be automatically added to your subscription, bringing your total licenses to {newTotalLicenses}.',
  NewTemporaryLicenseWarning:
    'A temporary license for {months} months will be created for this employee. This is a one time cost of {price}.',
});

export default messages;
